import HistoryInfoModel from "../model/history_info";
import TimelineModel from "../model/timeline";
import { fetchHistoryInfos, fetchTimeLine } from "../provider/api";

export async function getTimeline(): Promise<{ eventos: TimelineModel[] }> {
    try {
        const responseData = await fetchTimeLine();

        const items = responseData.data.map((item: any) => {
            const attributes = item.attributes;
            const imagemUrl = attributes.imagem?.data?.attributes?.url || null;
            const imagemThumbnailUrl = attributes.imagem?.data?.attributes?.formats?.thumbnail?.url || null;

            return new TimelineModel(
                item.id || null,
                attributes.titulo || null,
                attributes.descricao || null,
                imagemUrl,
                imagemThumbnailUrl,
                attributes.createdAt || null,
                attributes.updatedAt || null,
                attributes.publishedAt || null
            );
        });

        return { eventos: items };

    } catch (error: any) {
        console.error(`Erro (${error.response?.status}) ao buscar eventos`);
        console.log(error.toString());
        return { eventos: [] };
    }
}

export async function getAboutAbace(): Promise<{ sobre: HistoryInfoModel[] }> {
    try {
        const responseData = await fetchHistoryInfos();

        const items = responseData.data.map((item: any) => HistoryInfoModel.fromApiResponse(item));

        return { sobre: items };
    } catch (error: any) {
        console.error(`Erro (${error.response?.status}) ao buscar informações sobre a ABACE`);
        console.log(error.toString());
        return { sobre: [] };
    }
}